// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['financeiro', 'faturamento', 'triveni_governanca']


const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Variação Cambial',
    to: 'VariacaoCambialList'
  }
]

export default [
  {
    path: '/variacao-cambial',
    name: 'VariacaoCambialList',
    component: () => import('@/views/VariacaoCambial/VariacaoCambialPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Variação Cambial',
      breadcrumb: breadCrumb
    }
  }
]
